module.exports = __webpack_public_path__ + "img/timeLapseImg2.34a7241a.png";